// import core
import * as angular from 'angular';
import * as ngRouteModule from 'angular-route';

import ApiModule from '../api/api.module';
import CoreModule from '../core/core.module';

import ChooseOrganizationController from './chooseOrganization.controller';
import CreateANewPasswordController from './createANewPassword.controller';
import ResetPasswordController from './resetPassword.controller';
import SignInController from './signIn.controller';
import TermsOfUseController from './termsOfUse.controller';

import { CopyrightAndSocialIconsComponent } from './copyrightAndSocialIcons.component';

import DestinationService from './destination.service';

import 'angular-strap/dist/angular-strap.compat';
import 'angular-strap/dist/angular-strap.tpl';
import { bootstrapModule } from '../module_utils';

export default angular
  .module('SignInApp', [ApiModule, CoreModule, ngRouteModule, 'mgcrea.ngStrap'])
  .config(($routeProvider, $locationProvider) => {
    'ngInject';

    $locationProvider.hashPrefix('');

    $routeProvider
      .when('/', {
        template: require('./views/signIn.html'),
        controller: 'SignInController',
        controllerAs: '$ctrl',
      })
      // keeping this route so we can capture
      // /expire as :error param
      // e.g. /resetPassword/expired
      .when('/resetPassword/:error', {
        template: require('./views/resetPassword.html'),
        controller: 'ResetPasswordController',
        controllerAs: '$ctrl',
      })
      .when('/resetPassword/expired', {
        template: require('./views/resetPassword.html'),
        controller: 'ResetPasswordController',
        controllerAs: '$ctrl',
      })
      .when('/resetPassword', {
        template: require('./views/resetPassword.html'),
        controller: 'ResetPasswordController',
        controllerAs: '$ctrl',
      })
      .when('/createANewPassword/:code', {
        template: require('./views/createANewPassword.html'),
        controller: 'CreateANewPasswordController',
        controllerAs: '$ctrl',
      })
      .when('/termsOfUse', {
        template: require('./views/termsOfUse.html'),
        controller: 'TermsOfUseController',
        controllerAs: '$ctrl',
      })
      .when('/chooseOrganization', {
        template: require('./views/chooseOrganization.html'),
        controller: 'ChooseOrganizationController',
        controllerAs: '$ctrl',
      })
      .when('/destination/:destination*', {
        template: require('./views/signIn.html'),
        controller: 'SignInController',
        controllerAs: '$ctrl',
      })
      .otherwise('/');
  })
  .controller('ChooseOrganizationController', ChooseOrganizationController)
  .controller('CreateANewPasswordController', CreateANewPasswordController)
  .controller('ResetPasswordController', ResetPasswordController)
  .controller('SignInController', SignInController)
  .controller('TermsOfUseController', TermsOfUseController)
  .component('copyrightAndSocialIcons', CopyrightAndSocialIconsComponent)
  .service('DestinationService', DestinationService).name;

bootstrapModule('SignInApp');
